import axios from 'axios';
import { useEffect, useState } from 'react';
import imagePreview from '../assets/image-preview.svg';
import useAlert from '../hooks/useAlert';
import useCheckVideo from '../hooks/useCheckVideo';
import { useTranslation } from 'react-i18next';

const initialForm = {
	collectionId: '',
	fullName: '',
	description: '',
	ipfsUri: '',
	valuePrice: '',
	amount: 1
};

const getVideoId = (url) => {
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;
	const m = regex.exec(url);
	if (m !== null) {
		return m[3];
	}
	return null;
}

const checkYouTubeVideo = (urlToValidate) => {
	// 正規式
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;

	// 驗證
	if (regex.test(urlToValidate)) {
		return true;
	}
	
	return false;
};

const UserAssetCreate = (props) => {
	const { t, i18n } = useTranslation();
	const { show, close, getUserAssets, getUserCollection, collection } = props;
	const [form, setForm] = useState(initialForm);
	const [waiting, setWaiting] = useState(false);
	const [waiting1, setWaiting1] = useState(false);
	const { fullName, valuePrice, description, ipfsUri, amount } = form;
	const { isVideo, mediaType, checkForVideo } = useCheckVideo();

	const inputChange = (value, field) => {
		setForm({ ...form, [field]: value });
		if (field === 'ipfsUri') {
			checkForVideo(value);
		}
	}

	const token = localStorage.getItem('token');
	const { sendAlert } = useAlert();

	const clearForm = () => {
		setForm(initialForm);
	}

	useEffect(() => {
		setForm((currentValue) => {
			return {
				...currentValue,
				collectionId: collection.id,
			}
		});
	}, [collection]);

	const checkForm = (event) => {
		event.preventDefault();
		let hasError = false;

		if (Number(form.valuePrice) < 1) {
			sendAlert(t('user_asset_create.msg_valid_num'));
			hasError = true;
		}

		if (!Number.isInteger(Number(form.valuePrice))) {
			sendAlert(t('user_asset_create.msg_int_num'));
			hasError = true;
		}

		if (Number(form.amount) < 1 || Number(form.amount) > 1000) {
			sendAlert(t('user_asset_create.msg_valid_amt'));
			hasError = true;
		}

		if (!hasError) {
			setWaiting(true);
			createAsset();
		}
	}

	const createAsset = () => {
		axios.post('/items/assets/create_work_batch', form, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then((response) => {
			setWaiting(false);
			const message = response.data.message;
			if (message === 'success') {
				getUserCollection();
				getUserAssets();
				close();
				clearForm();
				sendAlert(t('user_asset_create.msg_create_ok'));
			}
		}).catch((error) => {
			setWaiting(false);
			const message = error.response.data.message;
			switch (message) {
				case 'Collection not found':
					sendAlert(t('user_asset_create.msg_existed'));
					break;
				case 'invalid BigNumber string (argument="value", value="aaa", code=INVALID_ARGUMENT, version=bignumber/5.7.0)':
					sendAlert(t('user_asset_create.msg_valid_num'));
					break;
				case 'A price of this work must be given':
					sendAlert(t('user_asset_create.msg_num_must'));
					break;
				case 'A full name of this work must be given':
					sendAlert(t('user_asset_create.msg_name_must'));
					break;
				case 'The image has not been uploaded':
					sendAlert(t('user_asset_create.msg_url_must'));
					break;
				case 'Sorry, only vendors can use this feature':
					sendAlert(t('user_asset_create.msg_vendor_only'));
					break;
				default:
					console.error(message);
					sendAlert(t('user_asset_create.msg_create_fail'));
					break;
			}
		});
	}

	const uploadImage = (event) => {
		setWaiting1(true);
		const file = event.target.files[0];
		if (file) {
			const formData = new FormData();
			formData.append('file', file, file.name);
			axios.post('/items/upload_ipfs', formData, {
				headers: {
					Authorization: `Bearer ${token}`,
				}
			}).then((response) => {
				const message = response.data.message;
				const data = response.data.data;
				if (message === 'success') {
					setWaiting1(false);
					// setForm({ ...form, ipfsUri: data.ipfsUri });
					inputChange(data.ipfsUri, 'ipfsUri');
				}
			}).catch((error) => {
				setWaiting1(false);
				const message = error.response.data.message;
				switch (message) {
					default:
						sendAlert(t('user_asset_create.msg_upload_fail'));
						break;
				}
			});
		} else{
			setWaiting1(false);
		}
	}

	return (
		<div className={`popup-wrap ${show ? 'active' : ''}`}>
			<div className='flow-wrap'>
				<div className='center-wrap'>
					<div className='close-popup' onClick={() => {
						if (waiting) return false;
						close();
					}}></div>
					<div className='popup-title'>{t('user_asset_create.title')}</div>

					<div className='form-wrap'>

						<label className='cover-preview' style={{ backgroundImage: `url(${ipfsUri || imagePreview})` }} onContextMenu={(e) => e.preventDefault()}>
							{/* <div className='text'>{t('user_asset_create.msg_preview')}</div> */}
							<input type='file' onChange={uploadImage} accept='image/jpg, image/jpeg, image/png, video/mp4' />
							{waiting1 ? (<progress value={null} />) : null}
							{isVideo ? (
								<video src={`${ form.ipfsUri }#t=0.15`} controls muted controlsList="nodownload"></video>
							) : (checkYouTubeVideo(form.ipfsUri.replace(/\s/g, '')) ? (
								<iframe 
									className='cover-preview'
									width="560" 
									height="315" 
									src={`https://www.youtube.com/embed/${getVideoId(form.ipfsUri.replace(/\s/g, ''))}`}
									title="YouTube video player" 
									frameBorder="0" 
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
									allowFullScreen>
								</iframe>
							) : null)}
						</label>


						<form onSubmit={checkForm}>
							<div className='input-wrap'>
								<div className='label'>{t('user_asset_create.item_name')}</div>
								<input type='text' value={fullName} onChange={(e) => { inputChange(e.target.value, 'fullName') }} />
							</div>

							<div className='input-wrap'>
								<div className='label'>{t('user_asset_create.item_desc')}</div>
								<textarea value={description} onChange={(e) => { inputChange(e.target.value, 'description') }}></textarea>
							</div>

							<div className='input-wrap'>
								<div className='label'>{t('user_asset_create.item_url')}</div>
								<input type='text' value={ipfsUri} onChange={(e) => { inputChange(e.target.value, 'ipfsUri') }} />
							</div>

							<div className='input-wrap'>
								<div className='label'>{t('user_asset_create.item_price')}</div>
								<input type='number' min='1' value={valuePrice} onChange={(e) => { inputChange(e.target.value, 'valuePrice') }} />
							</div>

							<div className='input-wrap'>
								<div className='label'>{t('user_asset_create.item_amount')}</div>
								<input type='number' min='1' max='1000' value={amount} onChange={(e) => { inputChange(e.target.value, 'amount') }} />
							</div>

							<div className='button-wrap'>
								<button className={ waiting ? 'disabled' : null } disabled={waiting}>
									{waiting ? (<progress value={null} />) : t('user_asset_create.btn_create')}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}

export default UserAssetCreate;